import { faShoppingBasket } from "@fortawesome/pro-solid-svg-icons/faShoppingBasket";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useProductStore } from "../stores/ProductStore";
import type { AddToCartButtonProps } from "../types/components/AddToCartButtonProps";

export const AddToCartButton = ({
	info,
	setSecondStage,
	inStock,
	secondStage,
	bogus = false,
}: AddToCartButtonProps) => {
	const { SetCurrentProductStep } = useProductStore((state) => state);

	const scrollToClosestSection = () => {
		requestAnimationFrame(() => {
			const targetSection =
				document.querySelector(".size-section-container") || document.querySelector(".delivery-section");

			if (targetSection) {
				const sectionTop = targetSection.getBoundingClientRect().top + window.pageYOffset;
				window.scrollTo({ top: sectionTop - 200, behavior: "smooth" });
			}
		});
	};

	return (
		<button
			className={`btn add-to-cart-button ${inStock || bogus ? "in-stock" : "disabled"} emphasis-button`}
			onClick={() => {
				if (!bogus) {
					SetCurrentProductStep("next");
					setSecondStage(true);
					scrollToClosestSection();
				}
			}}
			disabled={(!inStock || bogus) && true}
		>
			<div className="button-text">
				{inStock || bogus ? (
					<>
						<FontAwesomeIcon icon={faShoppingBasket} /> Add To Cart
					</>
				) : (
					<>Out Of Stock</>
				)}
			</div>
			{(inStock || bogus) && (
				<div className="pricing">
					{parseFloat(info.price_msrp) > parseFloat(info.price_retail) && (
						<div className="msrp">£{parseFloat(info.price_msrp).toFixed(2)}</div>
					)}
					<div className="retail">£{parseFloat(info.price_retail).toFixed(2)}</div>
				</div>
			)}
		</button>
	);
};
